import type { ProductGroupPresentationResult } from '@orus.eu/backend'

export function findDisplayableProductGroup(
  productGroups: readonly ProductGroupPresentationResult[],
  slug: string,
): ProductGroupPresentationResult | undefined {
  const productGroup = productGroups.find((group) => group.slug === slug)
  return productGroup && productGroup.contents.length > 0 ? productGroup : undefined
}
